export default __webpack_public_path__ + "static/media/carousel1.e78dbe89.png";